import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../../../routes/types';
import { customerGenialLimitQuery } from '../../../../../../store/customerDetail/selector';
import { ICustomerGenialLimitNormalized } from '../../../../../../store/customerDetail/types';

import { GenialLimitContent } from './components/Content';

export namespace GenialLimitTypes {
  export interface BaseProps {}
  export interface Props extends BaseProps, ICustomerGenialLimitNormalized {
    isLoading: boolean;
    error: any;
    onRefresh: () => void;
  }
}

export const GenialLimit: React.FC<GenialLimitTypes.BaseProps> = (props) => {
  const route = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const { data, loading, error, refresher } = useRecoilQuery(
    customerGenialLimitQuery({
      accountId: route.params.accountId,
      accountNumber: route.params.accountNumber,
    })
  );

  const componentProps: GenialLimitTypes.Props = {
    ...props,
    accountBalanceNormalized: data?.data.accountBalanceNormalized || '--',
    availableBalanceNormalized: data?.data.availableBalanceNormalized || '--',
    availableToAllocateNormalized: data?.data.availableToAllocateNormalized || '--',
    cardAllocatedNormalized: data?.data.cardAllocatedNormalized || '--',
    genialLimitNormalized: data?.data.genialLimitNormalized || '--',
    totalAllocatedNormalized: data?.data.totalAllocatedNormalized || '--',
    traderAllocatedNormalized: data?.data.traderAllocatedNormalized || '--',
    emptyGenialLimit: data?.data.emptyGenialLimit || false,
    isLoading: loading,
    error,
    onRefresh: refresher,
  };

  return <GenialLimitContent {...componentProps} />;
};
